import { AccordionAnimation } from "components/AccordionAnimation";
import { AmountSuperScript } from "components/design/AmountSuperScript";
import {
  Accordion,
  ItemGrid,
} from "components/DesignSystem/Accordion/Accordion";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";
import { AnimatePresence } from "framer-motion";
import { useGetPayrollQuery } from "store/apis/payroll";

type PayrollProps = {
  payrollId: string;
  entityId: string;
};

export const PayrollInfo = ({ payrollId, entityId }: PayrollProps) => {
  const { data: payroll, isLoading } = useGetPayrollQuery(
    {
      entityId,
      payrollId,
    },
    {
      skip: !entityId || !payrollId,
    }
  );

  if (isLoading) {
    return <Skeleton className="t-h-48" />;
  }

  return (
    <Accordion.Root type="single" collapsible defaultValue="PAYROLL">
      <Accordion.Item value="PAYROLL">
        <Accordion.Trigger>Linked Payroll</Accordion.Trigger>
        <Accordion.Content>
          <AnimatePresence>
            <AccordionAnimation duration={0.3}>
              <ItemGrid>
                <InfoItem label="Payroll Period">{payroll?.period}</InfoItem>
                {payroll?.source && (
                  <InfoItem label="Source">
                    <div className="t-flex t-items-center t-gap-2">
                      <Avatar alt={payroll?.source} src={""} />
                      <div className="first-letter:t-uppercase t-lowercase">
                        {payroll?.source}
                      </div>
                    </div>
                  </InfoItem>
                )}
                <InfoItem label="Date of import">
                  {dayjs(payroll?.created_at).format(DISPLAY_DATE)}
                </InfoItem>
                <InfoItem label="Gross pay">
                  <AmountSuperScript amount={Number(payroll?.gross_pay)} />
                </InfoItem>
              </ItemGrid>
            </AccordionAnimation>
          </AnimatePresence>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
